import cx from 'classnames';
import * as React from 'react';

interface PillProps extends React.ComponentPropsWithoutRef<'button'> {
  active: boolean;
}

export const Pill = ({ className, active, ...props }: PillProps) => (
  <button
    {...props}
    className={cx(
      'rounded-full px-5 py-2 xs:text-xl focus:outline-none focus:shadow-outline-blue',
      active ? 'bg-gray-300 font-bold' : 'text-gray-600',
      className
    )}
  />
);
